import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { REMOTE__generation_create_for_field_consumer } from '@/state/generation/user_task/REMOTE__generation_create_for_field_consumer';
import { SVGComponent } from '@/types/types';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { CONTEXT_MENU_ITEM__field_base } from '../_base/CONTEXT_MENU_ITEM__field_base';
import { HOOK_REQUEST_FOR_FIELD_CONSUMER__create } from './HOOK_REQUEST_FOR_FIELD_CONSUMER__create';

interface PROPS {
  Icon: SVGComponent;
  field_consumer: FIELD__image_asset;
  generation_tool: DTO__generation_tool;
}

export function CONTEXT_MENU_ITEM__field_image__edit_with_tool({ Icon, field_consumer, generation_tool }: PROPS) {
  const dispatch = use_dispatch();

  let request = HOOK_REQUEST_FOR_FIELD_CONSUMER__create(field_consumer, generation_tool);

  /*
   *
   */

  async function onClick() {
    await dispatch(REMOTE__generation_create_for_field_consumer(request));
  }

  /*
   *
   */

  /*
   *
   */

  if (request.is_stub()) return null;
  if (!field_consumer.image__is_initialized) return null;

  return <CONTEXT_MENU_ITEM__field_base Icon={Icon} text={'Edit with tool'} on_click={onClick} />;
}
